<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-form-group>
        <label>Apenas vigências ativas?</label>
        <b-form-radio-group
          v-model="form.options"
          :options="options"
          name="vigencia"
          plain
          stacked
          value-field="value"
        ></b-form-radio-group>
      </b-form-group>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="primary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      errors_array: [],
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      options: [
        { text: "Sim", value: 1 },
        { text: "Não", value: 0 }
      ],
      isFullscreen: false,
      helpForm: new Form({
        statusRecord: [],
        params: []
      }),
      form: new Form({
        options: "",
        tabfre_id: ""
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.segurado_id);
      }
    },
    onCreate(data) {
      console.log(data);
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Exportar Tabela de Frete";
      this.modal_botao = "Exportar";
      this.modal_acao = "i";
      this.form.reset();
      this.form.tabfre_id = data.tabfre_id;
      this.errors_array = "";
      this.errors_array = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/tabelafrete/exportar")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
            showModal = false;
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
